import {
    PicklistQueryResponse,
    unionWithAndFilters,
    unionWithOrFilters,
} from "../../../Engine/Core/Picklists/PicklistTypes";
import {
    DigestFilter,
    DigestLogicalOperator,
    DigestQueryFilter,
} from "../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";

import { FilterFunc, tryBuildUserFilter } from "./ComboboxFilterBuilder";
import { ComboBoxProps } from "./ComboBox";

export const defaultLimit = 10;

export const makeRequest = async (
    searchFilter: DigestFilter | undefined,
    comboboxProps: ComboBoxProps,
    filter?: FilterFunc,
    unionFiltersOperator?: DigestLogicalOperator
): Promise<PicklistQueryResponse> => {
    const { hasValidUserFilter, userFilter } = tryBuildUserFilter(filter);
    if (!hasValidUserFilter) {
        return {
            items: [],
            suitableCount: 0,
            columnMetas: [],
        };
    }
    const { limit, onQueryPicklist } = comboboxProps;
    const resultFilter =
        unionFiltersOperator == DigestLogicalOperator.Or
            ? unionWithOrFilters(searchFilter, userFilter)
            : unionWithAndFilters(searchFilter, userFilter);
    const defaultFilter: DigestQueryFilter = {
        filter: resultFilter,
        take: limit ?? defaultLimit,
    };
    return onQueryPicklist(defaultFilter);
};
